module.exports = __webpack_public_path__ + "img/spinner.54793005.gif";